module.exports = __webpack_public_path__ + "bg.b74dc44ee466aae60f08.jpg";


//////////////////
// WEBPACK FOOTER
// E:/Project/posSystem/src/assets/img/bg.jpg
// module id = ../../../../../src/assets/img/bg.jpg
// module chunks = styles